
import { getStoneRangeByCom, getGoldstoneByFactory, getCommodityDetail, getGoldstone, getStoneRange, putAddMadeInlaidCart, getCommodityMaterial, putAddMadeGoldCart, getMadeGoldAmount, getMadeInlaidAmount, getCategories } from './../../service/index'
import ZSelect from '@/components/Select'
import { zdsCategory } from './../../config/env'
import { isNullOrEmpty } from './../../util/util'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'

const ZJD = require('./../../config/ZJD.json')
const ZColor = require('./../../config/ZColor.json')
const KSStart = ['A0A', 'A0B', 'A0C']
export default {
data () {
return {
KSStart: KSStart,
currCategory: '',
zdsCategory: zdsCategory,
ZSQ: {Item: {}, List: [], Golds: []},
ZSJ: {Item: {}, List: [], Golds: []},
ZJD: ZJD,
ZColor: ZColor,
isZJQ: true,
IsChangeStyle: false,
CategoryList: [{'oid': '', 'name': ''}],
isShowZS: false
}
},
components: {
ZSelect, Group, Cell, XSwitch
},
created () {
this.getCategories()
},
mounted () {
this.GetDetail()
},
watch: {
'$route': function (to, from) {

}
},
methods: {
StandardGold (obj) {
obj.StandardGold = (Number(obj.ZQSJZ) + Number(obj.ZJZJZ)) / 2
},
onResultChange (val) {
console.log(val)
let vm = this
if (vm.currCategory === vm.zdsCategory.ZSQ) {
if (val.target === 0) {
this.ZSQ.List[val.id].MaterialCode = val.idx





} else if (val.target === 'JD') {
this.ZSQ.List[val.id].ZJD = val.idx
} else if (val.target === 'ZC') {
this.ZSQ.List[val.id].ZSD = val.idx
} else if (val.target === 'PL') {
this.ZSQ.List[val.id].ZPLBM = val.idx
if (val.idx === '01' || val.idx === '02' || val.idx === '03') {
this.isZJQ = true
} else {
this.isZJQ = false
}
}
} else if (vm.currCategory === vm.zdsCategory.ZSJ) {
if (val.target === 0) {
this.ZSJ.List[val.id].MaterialCode = val.idx
} else if (val.target === 'PL') {
this.ZSJ.List[val.id].ZPLBM = val.idx
if (val.idx === '01' || val.idx === '02' || val.idx === '03') {
this.isZJQ = true
} else {
this.isZJQ = false
}
}
}
},
del (idx) {
let vm = this
if (vm.currCategory === vm.zdsCategory.ZSQ) {
vm.ZSQ.List.splice(idx, 1)
} else if (vm.currCategory === vm.zdsCategory.ZSJ) {
vm.ZSJ.List.splice(idx, 1)
}
},
add () {
let vm = this
if (vm.currCategory === vm.zdsCategory.ZSQ) {
vm.ZSQ.List.push({
CommodityOid: vm.ZSQ.Item.Oid,
MaterialCode: '',
ZZJQH: '',
FactoryOid: '',
ZJD: '',
ZSD: '',
Number: vm.ZSQ.Item.Number,
Name: vm.ZSQ.Item.Name,
Price: vm.ZSQ.Item.Price,
Amount: 0,
Unit: vm.ZSQ.Item.Unit,
ZZSZL: '',
Qty: 1,
ZPMC: vm.ZSQ.Item.ZPMC,
ZPLBM: vm.ZSQ.Item.ZPM,
StoneRanges: vm.ZSQ.Item.StoneRanges,
Golds: [],
Note: '',
IsChangeStyle: vm.ZSQ.Item.IsChangeStyle
})
} else if (vm.currCategory === vm.zdsCategory.ZSJ) {
vm.ZSJ.List.push({
Oid: vm.ZSJ.Item.Oid,
Number: vm.ZSJ.Item.Number,
Name: vm.ZSJ.Item.Name,
MaterialCode: '',
Price: vm.ZSJ.Item.Price,
Amount: 0,
Unit: vm.ZSJ.Item.Unit,
Specifications: vm.ZSJ.Item.Specifications,
StandardGold: vm.ZSJ.Item.StandardGold,
ZQSJZ: vm.ZSJ.Item.ZQSJZ,
ZJZJZ: vm.ZSJ.Item.ZJZJZ,
ZPMC: vm.ZSJ.Item.ZPMC,
ZPLBM: vm.ZSJ.Item.ZPM,
Qty: 1,
Note: '',
Size: 0,
IsChangeStyle: vm.ZSJ.Item.IsChangeStyle
})
}
setTimeout(() => {
document.documentElement.scrollTop = document.body.scrollTop = document.body.scrollHeight - 100
}, 100)
},
GetDetail () {
let vm = this
let pData = {
commodityOid: vm.$route.params.id,
bannerOId: vm.$route.query.bannerOId 
}
let params = vm.$route.params
vm.currCategory = params.type

getCommodityDetail(pData, (result) => {
if (result.code === '1') {
let data = JSON.parse(result.data)
if (vm.currCategory === vm.zdsCategory.ZSQ) {
vm.ZSQ.Item = {
Oid: data.OId,
Number: data.Number,
Name: data.Name,
Price: data.Price,
Unit: data.Unit,
ZPMC: data.ZPMC,
ZPM: data.ZPM,
IsChangeStyle: false
}
vm.IsChangeStyle = data.IsChangeStyle
vm.doZJQ()
vm.getStoneRangeByCom(() => {
vm.add()
})
} else if (vm.currCategory === vm.zdsCategory.ZSJ) {
data.ZQSJZ = data.ZJZJZ = 0
vm.ZSJ.Item = {
Oid: data.OId,
Number: data.Number,
Name: data.Name,
Price: data.Price,
Unit: data.Unit,
Specifications: data.Specifications,
StandardGold: (data.ZQSJZ + data.ZJZJZ) / 2,
ZQSJZ: data.ZQSJZ,
ZJZJZ: data.ZJZJZ,
ZPMC: data.ZPMC,
ZPM: data.ZPM,
IsChangeStyle: false
}
vm.IsChangeStyle = data.IsChangeStyle
vm.getCommodityMaterial()
vm.add()
}
}
})
},
getStoneRangeByCom (call) {
let vm = this
getStoneRangeByCom(vm.$route.params.id, (result) => {
if (result.code === '1') {
if (vm.currCategory === vm.zdsCategory.ZSQ) {
let ls = JSON.parse(result.data)
if (ls.length > 0) {
vm.ZSQ.Item.StoneRanges = ls



} else {
vm.ZSQ.Item.StoneRanges = []
}
}
}
call()
})
},
getGoldstoneByFactory (id, call) {
getGoldstoneByFactory(id, (result) => {
if (result.code === '1') {
call(JSON.parse(result.data))
} else {
call([])
}
})
},
getGoldstone () {
let vm = this
getGoldstone(vm.$route.params.id, (result) => {
if (result.code === '1') {
if (vm.currCategory === vm.zdsCategory.ZSQ) {
let ls = JSON.parse(result.data)
if (ls.length > 0) {
vm.ZSQ.Golds = ls.map((item, index) => ({
oid: item.ZJSBM,
name: item.ZJSMC
}))



}
}
}
})
},
getCommodityMaterial () {
let vm = this
getCommodityMaterial((result) => {
if (result.code === '1') {
let ls = JSON.parse(result.data)
if (ls.length > 0) {
vm.ZSJ.Golds = ls.map((item, index) => ({
oid: item.ZJSBM,
name: item.ZJSMC
}))
}
}
})
},
GetStoneRange (id, call) {
let vm = this
getStoneRange(vm.$route.params.id, id, (result) => {
if (result.code === '1') {
call(JSON.parse(result.data))
} else {
call([])
}
})
},
getMadeInlaidAmount (idx) {
let vm = this
let obj = vm.ZSQ.List[idx]
let pData = {
CommodityOid: obj.Oid,
MaterialCode: obj.MaterialCode,
ZZJQH: obj.ZZJQH,
ZZSZL: obj.ZZSZL,
FactoryOid: obj.FactoryOid,
ZJD: obj.ZJD,
ZSD: obj.ZSD,
Qty: obj.Qty
}
if (!isNullOrEmpty(pData.MaterialCode)) {
vm.showToast('请选择材料名称')
return
}
if (!isNullOrEmpty(pData.MaterialCode)) {
vm.showToast('请填写指圈')
return
}
if (!isNullOrEmpty(pData.MaterialCode)) {
vm.showToast('请填写主石重')
return
}
if (pData.Qty <= 0) {
vm.showToast('请填写数量')
return
}
getMadeInlaidAmount(pData, (result) => {
if (result.code === '1') {
let data = JSON.parse(result.data)
obj.Price = data.Prcie
obj.Amount = data.Amount
}
})
},
getMadeGoldAmount (idx) {
let vm = this
let obj = vm.ZSJ.List[idx]
let pData = {
CommodityOid: obj.Oid,
MaterialCode: obj.MaterialCode,
MinGold: obj.ZQSJZ,
MaxGold: obj.ZJZJZ,
StandardGold: obj.StandardGold,
Qty: obj.Qty,
Size: obj.Size
}
if (!isNullOrEmpty(pData.MaterialCode)) {
vm.showToast('请选择材料名称')
return
}
if (pData.MinGold < 0) {
vm.showToast('请填写最小金重')
return
}
if (pData.MaxGold <= 0) {
vm.showToast('请填写最大金重')
return
}
if (pData.Qty <= 0) {
vm.showToast('请填写数量')
return
}
getMadeGoldAmount(pData, (result) => {
if (result.code === '1') {
let data = JSON.parse(result.data)
obj.Price = data.Prcie
obj.Amount = data.Amount
}
})
},
putAddMadeInlaidCart () {
let vm = this
let params = vm.$route.params
let postData = {
CommodityOid: params.id,
InlaidDetail: vm.ZSQ.List
}

if (postData.InlaidDetail.filter(c => c.ZPLBM === '').length > 0) {
vm.showToast('品类不能为空')
return
}
if (postData.InlaidDetail.filter(c => (c.ZPLBM === '01' && c.ZZJQH === '') || (c.ZPLBM === '02' && c.ZZJQH === '') || (c.ZPLBM === '03' && c.ZZJQH === '') || (c.ZPLBM === '04' && c.ZZJQH === '') || (c.ZPLBM === '35' && c.ZZJQH === '')).length > 0) {
vm.showToast('指圈规格不能为空')
return
}
if (vm.ZSQ.List.filter(c => c.Amount <= 0).length > 0) {
vm.showToast('请填写完整的信息')
return
} else {
putAddMadeInlaidCart(postData, (result) => {
if (result.code === '1') {
vm.showAlert('提交成功！', () => {
history.go(-1)
})
}
})
}
},
putAddMadeGoldCart () {
let vm = this
let params = vm.$route.params
let postData = {
CommodityOid: params.id,
GoldDetail: vm.ZSJ.List.map((item, index) => ({
CommodityOid: params.id,
MaterialCode: item.MaterialCode,
MinGold: item.ZQSJZ,
MaxGold: item.ZJZJZ,
StandardGold: item.StandardGold,
Qty: item.Qty,
ZPLBM: item.ZPLBM,
Size: item.Size,
Note: item.Note,
IsChangeStyle: item.IsChangeStyle
}))
}
if (postData.GoldDetail.filter(c => c.ZPLBM === '').length > 0) {
vm.showToast('品类不能为空')
return
}
if (vm.ZSJ.List.filter(c => c.Amount <= 0).length > 0) {
vm.showToast('请填写完整的信息')
return
}
putAddMadeGoldCart(postData, (result) => {
if (result.code === '1') {
vm.showAlert('提交成功！', () => {
history.go(-1)
})
}
})
},
putCart () {
let vm = this
if (vm.currCategory === vm.zdsCategory.ZSQ) {
vm.putAddMadeInlaidCart()
} else if (vm.currCategory === vm.zdsCategory.ZSJ) {
vm.putAddMadeGoldCart()
}
},
checkZSL (idx) {
let vm = this
let obj = vm.ZSQ.List[idx]
let ls = obj.StoneRanges.filter(c => c.ZZSQSZ <= obj.ZZSZL && c.ZZSJZZ >= obj.ZZSZL)
if (!(ls && ls.length > 0)) {
obj.ZZSZL = 0




vm.showToast('不在主石重范围,请重新填写')
this.ZSQ.List[idx].Golds = []
} else {
obj.FactoryOid = ls[0].OId
vm.getGoldstoneByFactory(obj.FactoryOid, (res) => {
this.ZSQ.List[idx].Golds = res.map((item, index) => ({
oid: item.ZJSBM,
name: item.ZJSMC
}))
})
}
},
checkZJQ (idx) {
let vm = this
let obj = vm.ZSQ.List[idx]
if (obj.ZZJQH >= 3 && obj.ZZJQH <= 30) {
if ((obj.ZZJQH) % 0.5 === 0) {

} else {
obj.ZZJQH = ''
vm.showToast('指圈为0.5整数倍')

}
return false
} else {
obj.ZZJQH = ''
vm.showToast('指圈超出[3-30]范围')
}
},
doZJQ () {
let ls = KSStart.filter(c => (c.indexOf(this.ZSQ.Item.Number.substring(0, 3)) > -1))
this.isZJQ = ls.length > 0
},
getCategories () {
let vm = this
getCategories(null, (result) => {
if (result.code === '1') {
let ls = JSON.parse(result.data)
for (let item of ls) {
vm.CategoryList.push({
oid: item.CategoryNumber,
name: item.CategoryName
})
}
}
})
}
}

}



// WEBPACK FOOTER //
// ./src/page/product/outbatchdetail.vue